import styled from "styled-components";

const DropDown = styled.div`
  position: absolute;
  width: 100%;
  z-index: 2;
  border: 1px solid ${props => props.theme.lightgrey};
  font-size: 1rem;
  top: 100%;
`;

const DropDownItem = styled.div`
  cursor: pointer;
  border-bottom: 1px solid ${props => props.theme.lightgrey};
  background: ${props => (props.highlighted ? "#f7f7f7" : "white")};
  padding: 0.5rem;
  transition: all 0.2s;
  ${props => (props.highlighted ? "padding-left: 1rem;" : null)};
  display: flex;
  align-items: center;
  border-left: 10px solid
    ${props => (props.highlighted ? props.theme.secondary : "white")};
  display: flex;
  .customer-no {
    flex: 0 0 25%;
    text-align: left;
  }
  .customer-name {
    flex: 1;
  }
  .customer-location {
    flex: 0 0 35%;
    text-align: left;
  }
`;

const SearchStyles = styled.div`
  position: relative;
  /* margin-bottom: 10px; */
`;

export { DropDown, DropDownItem, SearchStyles };
